import { PageTitle } from "../../components/Headers";
import { PageBody } from "../../components/PageBody";
import { Helmet } from "react-helmet-async";
import { GridDiv, GridDivContainer } from "../../components/GridDiv";
import { ProjectLink } from "../../components/ProjectLink";
import { ArticleParagraph } from "../../components/Paragraphs";
import { getProjectsForSection } from "../../config/projects";
import { getSEOForPath } from "../../config/seo";
import { useLocation } from "react-router-dom";

// Get games projects from centralized config
const gamesProjects = getProjectsForSection('/games');

export const GamesHome = () => {
    const location = useLocation();
    const seo = getSEOForPath(location.pathname);

    return (
        <PageBody>
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                {seo.keywords && <meta name="keywords" content={seo.keywords} />}
            </Helmet>

            <PageTitle title="Games" />

            <ArticleParagraph
                lines={[
                    "Interactive game simulations and analysis tools. These projects explore probability, statistics, and game theory through playable simulations and data visualisation.",
                    "Each game includes both a playable version and simulation tools to analyse outcomes across thousands of games. Use these tools to explore questions like: How many turns does an average game take? What's the probability of winning from different starting positions?"
                ]}
            />

            <GridDivContainer>
                {gamesProjects.map((project) => (
                    <GridDiv
                        key={project.to}
                        widthClasses="w-full sm:w-1/2"
                    >
                        <ProjectLink
                            to={project.to}
                            title={project.title}
                            icon={project.icon}
                            colorClass={project.colorClass}
                        />
                    </GridDiv>
                ))}
            </GridDivContainer>
        </PageBody>
    );
};
